import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__logos-col">
            <div className="footer__logo-row">
              <div className="footer__logo-icon footer__logo-icon--blue">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
              </div>
              <div className="footer__logo-icon footer__logo-icon--red">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
              </div>
            </div>
            <span className="footer__brand-name">سبزه میدون</span>
            <p style={{ fontSize: '13px', color: '#888', marginTop: '5px' }}>
              فروشگاه تخصصی نهاده‌های کشاورزی
            </p>
          </div>

          <div className="footer__services-col">
            <div className="footer__service-group">
              <h4 className="footer__service-title">خدمات مشتری</h4>
              <ul className="footer__service-list">
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                  <span>پشتیبانی ۲۴ ساعته</span>
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                  <span>ضمانت اصالت کالا</span>
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                  <span>پرداخت در محل</span>
                </li>
              </ul>
            </div>
            <div className="footer__service-group">
              <h4 className="footer__service-title">دسترسی سریع</h4>
              <ul className="footer__service-list">
                <li><Link to="/shop">فروشگاه</Link></li>
                <li><Link to="/articles">مقالات</Link></li>
                <li><Link to="/experiences">تجارب کشاورزان</Link></li>
                <li><Link to="/advertisements">آگهی‌ها</Link></li>
                <li><Link to="/transport">بار و ماشین</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer__desc-col">
            <h4 className="footer__service-title">درباره ما</h4>
            <p className="footer__desc-text">
              سبزه میدون با هدف تأمین نهاده‌های کشاورزی با کیفیت و ایجاد بستری برای تبادل دانش بین کشاورزان، فعالیت خود را آغاز کرده است. 
              ما با بهره‌گیری از تجارب کاری و تکنولوژی‌های روز دنیا، محصولاتی با کیفیت و قیمت مناسب را در اختیار شما قرار می‌دهیم.
            </p>
          </div>
        </div>
      </div>

      <div className="footer__contact-bar">
        <div className="container">
          <div className="footer__contact-inner">
            <div className="footer__social-bar">
              <a href="#" className="footer__social-btn" aria-label="اینستاگرام">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </a>
              <a href="#" className="footer__social-btn" aria-label="تلگرام">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
              </a>
              <a href="#" className="footer__social-btn" aria-label="واتساپ">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </a>
            </div>

            <div className="footer__contact-label">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              <span>تماس با ما</span>
              <span>۰۹۳۳۵۷۵۴۸۲۰</span>
            </div>

            <div className="footer__contact-info">
              <div className="footer__contact-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                <span>۰۹۳۳۵۷۵۴۸۲۰</span>
              </div>
              <div className="footer__contact-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <span>info@greenbeltiran.com</span>
              </div>
              <div className="footer__contact-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                <span>اصفهان، مبارکه، دیزیچه، خیابان امام خمینی، باغ ملاباشی</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom-bar">
        <div className="container">
          <div className="footer__bottom-inner">
            <p className="footer__copyright">
              تمامی حقوق مادی و معنوی این سایت متعلق به <strong>سبزه میدون</strong> می‌باشد.
            </p>
            <button className="footer__back-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <span>بازگشت به بالا</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="18 15 12 9 6 15"/></svg>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;